/* eslint-disable max-len */
import React from 'react';

const iconAccessibility = () => (
  <svg
    width="18px"
    height="20px"
    viewBox="0 0 18 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-59.000000, -553.000000)">
        <g transform="translate(56.000000, 551.000000)">
          <path d="M12,2 C13.1,2 14,2.9 14,4 C14,5.1 13.1,6 12,6 C10.9,6 10,5.1 10,4 C10,2.9 10.9,2 12,2 L12,2 Z M21,9 L15,9 L15,22 L13,22 L13,16 L11,16 L11,22 L9,22 L9,9 L3,9 L3,7 L21,7 L21,9 L21,9 Z" />
        </g>
      </g>
    </g>
  </svg>
);

export default iconAccessibility;
